export default __webpack_public_path__ + "static/media/IMG_4048.5ca1d137.JPG";